import { isPreferenceDisabled } from 'Common/Security/SecurityHelpers';
import { PreferencesEnum } from 'Common/Security/PreferencesEnum';

export const filterOptions = [
  { value: 0, label: 'All Items' },
  {
    value: 1,
    label: 'Last Physical Item',
  },
  { value: 2, label: 'On Hand Items' },
  {
    value: 3,
    label: 'Order Access Items',
  },
];

export const sortOptions = [
  { value: 0, label: 'Item Code' },
  { value: 1, label: 'Item Description' },
];

export const groupOptions = [
  { value: 0, label: 'None' },
  { value: 1, label: 'Distributor' },
  { value: 2, label: 'Storage Location' },
  { value: 3, label: 'Item Group' },
];

export const includeOnHand = (currentOnHand, preferences) => {
  if (!currentOnHand) {
    return currentOnHand;
  }
  const disabled = isPreferenceDisabled(PreferencesEnum.PhysicalReportIncludeCurrentOnHand, preferences);
  return disabled ? false : currentOnHand;
};



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/physicalinventoryreport/helper/index.js